import { css } from "@emotion/core";
import {
  color,
  fontTypes,
  fontSizes,
  fontWeight,
} from "../../constants/commons";

export const sidebarBackground = (color: string | undefined) => css`
  background: ${color};
`;

export const partnerStyle = css`
  max-width: 100em;
  margin: auto;
  .responsive-widget-item {
    box-shadow: none;
  }
  .join-us-btn-container {
    position: -webkit-sticky;
    position: sticky;
    bottom: 0;
    .custom-button {
      width: 100%;
    }
  }
  .back-button-style {
    color: ${color.red};
    font-family: ${fontTypes.bold};
    font-weight: ${fontWeight.medium};
  }
  .back-button-style:hover {
    text-decoration: none;
  }

  .footer-background {
    background: linear-gradient(
      -90deg,
      ${color.whitishGray} 0%,
      ${color.white} 100%
    );
  }

  /* Extra small devices (portrait phones, less than 576px) */
  @media (max-width: 575.98px) {
    .responsive-image-header {
      margin: 0.3em 0 0 0;
      border-radius: 0.625em;
      height: 16em;
      width: auto;
    }

    .responsive-partner-heading-right {
      color: ${color.darkMaroon};
      font-family: ${fontTypes.bold};
      display: flex;
      align-items: center;
      font-size: ${fontSizes.lg};
    }
    .responsive-description {
      color: ${color.lightishGray};
      font-family: ${fontTypes.bodyFont};
      font-size: ${fontSizes.xs};
      margin: 1em 0 1em 0;
    }
    .responsive-subheading {
      color: ${color.lightishGray};
      font-family: ${fontTypes.meduim};
      font-size: ${fontSizes.xxs};
      font-weight: ${fontWeight.medium};
      display: flex;
      align-items: center;
    }
    .responsive-landing-header-left {
      color: ${color.partnerPageShade};
      font-family: ${fontTypes.black};
      font-size: ${fontSizes.xlg};
    }
    .single-section {
      margin-top: 1em;
    }
    .responsive-margin-container {
      margin-top: 2.5em;
    }
  }

  /* Small devices (landscape phones, 576px and up) */
  @media (min-width: 576px) and (max-width: 767.98px) {
    .responsive-image-header {
      border-radius: 0.625em;
      width: 100%;
    }
    .responsive-partner-heading-right {
      color: ${color.darkMaroon};
      font-family: ${fontTypes.bold};
      font-size: ${fontSizes.lg};
      display: flex;
      align-items: center;
    }
    .responsive-description {
      color: ${color.lightishGray};
      font-family: ${fontTypes.bodyFont};
      font-size: ${fontSizes.sm};
      margin: 1em 0 1em 0;
    }
    .responsive-subheading {
      color: ${color.lightishGray};
      font-family: ${fontTypes.meduim};
      font-size: ${fontSizes.xxs};
      font-weight: ${fontWeight.medium};
      display: flex;
      align-items: center;
    }
    .responsive-landing-header-left {
      color: ${color.partnerPageShade};
      font-family: ${fontTypes.black};
      font-size: ${fontSizes.xlg};
    }
    .single-section {
      margin-top: 1em;
    }
    .sticky-container {
      position: sticky;
      top: 10%;
      height: fit-content;
      position: -webkit-sticky;
      padding: 0 2em;
    }
    .responsive-margin-container {
      margin-top: 1.5em;
    }
  }

  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) and (max-width: 991.98px) {
    .responsive-image-header {
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 0;
    }
    .sticky-container {
      position: sticky;
      top: 10%;
      height: fit-content;
      position: -webkit-sticky;
      min-height: 40em;
      padding: 0 2em;
    }
    .responsive-partner-heading-right {
      color: ${color.darkMaroon};
      font-family: ${fontTypes.bold};
      font-size: ${fontSizes.xlg};
      display: flex;
      align-items: center;
    }
    .responsive-description {
      color: ${color.lightishGray};
      font-family: ${fontTypes.bodyFont};
      font-size: ${fontSizes.sm};
      margin: 1em 0 1em 0;
    }
    .responsive-subheading {
      color: ${color.lightishGray};
      font-family: ${fontTypes.meduim};
      font-size: ${fontSizes.xxs};
      font-weight: ${fontWeight.medium};
      display: flex;
      align-items: center;
    }
    .responsive-landing-header-left {
      color: ${color.partnerPageShade};
      font-family: ${fontTypes.black};
      font-size: ${fontSizes.xlg};
    }
    .single-section {
      margin-top: 2em;
    }

    .partner-padding-style {
      padding: 0 5em;
    }
  }

  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) and (max-width: 1199.98px) {
    .responsive-image-header {
      height: 15em;
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
    }
    .sticky-container {
      position: sticky;
      top: 8%;
      position: -webkit-sticky;
      height: fit-content;
      min-height: 40em;
      border-radius: 0.7em;
      padding: 0 2em;
    }
    .responsive-partner-heading-right {
      color: ${color.darkMaroon};
      font-family: ${fontTypes.bold};
      font-size: ${fontSizes.xxlg};
      display: flex;
      align-items: center;
    }
    .responsive-subheading {
      color: ${color.lightishGray};
      font-family: ${fontTypes.meduim};
      display: flex;
      align-items: center;
      font-weight: ${fontWeight.medium};
    }
    .responsive-description {
      color: ${color.lightishGray};
      font-family: ${fontTypes.bodyFont};
      font-size: ${fontSizes.sm};
      margin: 1em 0 1em 0;
    }
    .responsive-landing-header-left {
      color: ${color.partnerPageShade};
      font-family: ${fontTypes.black};
      font-size: ${fontSizes.xxlg};
    }
    .single-section {
      margin-top: 3em;
    }
    .partner-padding-style {
      padding: 0 5em;
    }
  }

  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {
    .responsive-image-header {
      height: auto;
      max-height: 20em;
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
    }
    .sticky-container {
      position: sticky;
      top: 10%;
      height: fit-content;
      position: -webkit-sticky;
      min-height: 40em;
      border-radius: 0.7em;
      padding: 0 2em;
    }
    .responsive-partner-heading-right {
      color: ${color.darkMaroon};
      font-family: ${fontTypes.bold};
      font-size: ${fontSizes.xxlg};
      display: flex;
      align-items: center;
    }
    .responsive-subheading {
      color: ${color.lightishGray};
      font-family: ${fontTypes.meduim};
      display: flex;
      align-items: center;
      font-weight: ${fontWeight.medium};
    }
    .responsive-description {
      color: ${color.lightishGray};
      font-family: ${fontTypes.bodyFont};
    }
    .responsive-landing-header-left {
      color: ${color.partnerPageShade};
      font-family: ${fontTypes.black};
      font-size: ${fontSizes.xlg};
    }
    .single-section {
      margin-top: 3em;
    }
    .partner-padding-style {
      padding: 0 5em;
    }
    .partnerspecific-padding-container {
      padding-left: 10em;
    }
  }
`;
